import { render, staticRenderFns } from "./SenatiCalidadVenta.vue?vue&type=template&id=3c9bcfb2&"
import script from "./SenatiCalidadVenta.vue?vue&type=script&lang=js&"
export * from "./SenatiCalidadVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports